import { createSelector } from 'reselect';

const selectSuppliers = (state: any) => state.suppliers;


export const selectSuppliersCurrentItem = createSelector([selectSuppliers], (suppliers) => suppliers.current);

export const selectSuppliersListItems = createSelector([selectSuppliers], (suppliers) => suppliers.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectSuppliersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSuppliersQueryItems = createSelector([selectSuppliers], (suppliers) => suppliers.query);

export const selectSuppliersCreatedItem = createSelector([selectSuppliers], (suppliers) => suppliers.create);

export const selectSuppliersUpdatedItem = createSelector([selectSuppliers], (suppliers) => suppliers.update);

export const selectSuppliersReadItem = createSelector([selectSuppliers], (suppliers) => suppliers.read);

export const selectSuppliersDeletedItem = createSelector([selectSuppliers], (suppliers) => suppliers.delete);

export const selectSuppliersSearchedItems = createSelector([selectSuppliers], (suppliers) => suppliers.search);

export const selectSuppliersItemsCount = createSelector([selectSuppliers], (suppliers) => suppliers.count);

export const selectSuppliersItemsFilter = createSelector([selectSuppliers], (suppliers) => suppliers.filter);